import React, { useContext, memo } from 'react';
import { TextContext } from '@/utils/contexts/TextContext';

import EditLetterForm from '@/views/pages/Letter/elements/EditLetterForm';

const EditLetter = () => {
	const { contextState, contextDispatch } = useContext(TextContext);
	const saveData = (data) => {
		contextDispatch({
			type: 'submitLetterMetadataEdit', payload: {
				...data,
				recipient: data.recipient.value,
				titleType: data.titleType.value,
				date: data.letterDate,
				category: data.category.value,
			},
		});
	};

	const cancelForm=() => {
		contextDispatch({
			type: 'setEditLetterMetadata', payload: {
				EditLetterFormMetadata: false,
			},
		});
	};

	return (
		<EditLetterForm 
			letterData={ contextState.letterData }
			saveData={ saveData }
			cancelForm={ cancelForm }
		/>
	);
};

export default memo(EditLetter);